import {createAction} from 'redux-actions';

const MENU_OFF = 'MENU_OFF';
const MENU_ON = 'MENU_ON';
const MENU_SWITCH = 'MENU_CLICK';

export const menuOff = createAction(MENU_OFF);
export const menuOn = createAction(MENU_ON);
export const menuSwitch = createAction(MENU_SWITCH);

export function menuClick(isMenuOpened) {
  return dispatch => {
    if (isMenuOpened) {
      dispatch(menuOff());
    } else {
      dispatch(menuOn());
    }
  };
}

const initialState = {
  isMenuOpened: false
};
const menuReducer = (state = initialState, action) => {
  switch (action.type) {
  case MENU_OFF: {
    return {isMenuOpened: false};
  }
  case MENU_ON: {
    return {isMenuOpened: true};
  }
  case MENU_SWITCH: {
    return {isMenuOpened: !state.isMenuOpened};
  }
  default: {
    return state;
  }
  }
};

export function isMenuOpened(state) {
  return state.menu.isMenuOpened;
}

export default menuReducer;



// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js